import { isKetchAvailable, showKetchPreferences } from '@src/service/ketch/ketch'
import Typography from '@ui/Typography'

import * as styles from './UniversalLoginLegalFooter.css'

const UniversalLoginLegalFooter = () => {
  return (
    <>
      <Typography
        component="div"
        variant="caption1"
        color="textTertiary"
        fontWeight="regular"
        className={styles.terms}
      >
        By continuing, you acknowledge and accept our
      </Typography>
      <Typography
        component="div"
        variant="caption1"
        color="textTertiary"
        fontWeight="regular"
        className={styles.terms}
      >
        <a href="https://www.quo.com/terms" target="_blank" className={styles.link}>
          Terms of Service
        </a>{' '}
        and{' '}
        <a href="https://www.quo.com/privacy" target="_blank" className={styles.link}>
          Privacy Policy
        </a>
        .
      </Typography>
      {isKetchAvailable() && (
        <Typography
          component="div"
          variant="caption1"
          color="textTertiary"
          fontWeight="regular"
          className={styles.terms}
        >
          You can adjust your{' '}
          <button
            type="button"
            onClick={showKetchPreferences}
            className={styles.linkButton}
          >
            privacy settings
          </button>{' '}
          at any time.
        </Typography>
      )}
    </>
  )
}

export default UniversalLoginLegalFooter
